import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-label text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-700 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}